"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECENT_FAVORITES_FILTERS = void 0;
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Filter_1 = __importDefault(require("./Filter"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_2 = require("swiper/react");
var swiper_1 = require("swiper");
var Slide_1 = __importDefault(require("./Slide"));
require("./styles.scss");
var RECENT_FAVORITES_FILTERS;
(function (RECENT_FAVORITES_FILTERS) {
    RECENT_FAVORITES_FILTERS["RECENT"] = "recent";
    RECENT_FAVORITES_FILTERS["FAVORITE"] = "favorites";
    RECENT_FAVORITES_FILTERS["ALL"] = "all";
})(RECENT_FAVORITES_FILTERS = exports.RECENT_FAVORITES_FILTERS || (exports.RECENT_FAVORITES_FILTERS = {}));
var RecentAndFavoritesGames = function (_a) {
    var _b, _c, _d;
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _e = (0, react_1.useState)(RECENT_FAVORITES_FILTERS.ALL), activeFilter = _e[0], setActiveFilter = _e[1];
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var viewAllHandler = (0, react_1.useCallback)(function () {
        if (activeFilter === RECENT_FAVORITES_FILTERS.ALL)
            router.push(generateUrlWithLang("/games/recent-favorites"));
        else
            router.push(generateUrlWithLang("/games/".concat(activeFilter)));
    }, [router, activeFilter, generateUrlWithLang]);
    var slider = (0, react_1.useRef)(null);
    var recentGames = (0, swr_hooks_1.useRecentGames)().data;
    var favoriteGames = (0, swr_hooks_1.useFavoriteGames)().data;
    var filteredGames = (0, react_1.useMemo)(function () {
        if (activeFilter === RECENT_FAVORITES_FILTERS.FAVORITE)
            return (favoriteGames === null || favoriteGames === void 0 ? void 0 : favoriteGames.list) || [];
        if (activeFilter === RECENT_FAVORITES_FILTERS.RECENT)
            return recentGames || [];
        var allGames = __spreadArray(__spreadArray([], (recentGames || []), true), ((favoriteGames === null || favoriteGames === void 0 ? void 0 : favoriteGames.list) || []), true);
        return Array.from(new Map(allGames.map(function (game) { return [game.id, game]; })).values());
    }, [recentGames, favoriteGames, activeFilter]);
    if (!isAuth ||
        !recentGames ||
        !favoriteGames ||
        ((recentGames === null || recentGames === void 0 ? void 0 : recentGames.length) === 0 && ((_b = favoriteGames === null || favoriteGames === void 0 ? void 0 : favoriteGames.list) === null || _b === void 0 ? void 0 : _b.length) === 0))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("h1", null, t('recentAndFavoriteGames')),
                react_1.default.createElement("section", { className: styles_module_scss_1.default.headerBtnsWrapper },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.headerBtns },
                        react_1.default.createElement(Filter_1.default, { slug: RECENT_FAVORITES_FILTERS.FAVORITE, onClick: function () {
                                return setActiveFilter(RECENT_FAVORITES_FILTERS.FAVORITE);
                            }, isActive: activeFilter === RECENT_FAVORITES_FILTERS.FAVORITE, title: t(RECENT_FAVORITES_FILTERS.FAVORITE) }),
                        react_1.default.createElement(Filter_1.default, { slug: RECENT_FAVORITES_FILTERS.RECENT, onClick: function () { return setActiveFilter(RECENT_FAVORITES_FILTERS.RECENT); }, isActive: activeFilter === RECENT_FAVORITES_FILTERS.RECENT, title: t(RECENT_FAVORITES_FILTERS.RECENT) }),
                        react_1.default.createElement(Filter_1.default, { slug: RECENT_FAVORITES_FILTERS.ALL, onClick: function () { return setActiveFilter(RECENT_FAVORITES_FILTERS.ALL); }, isActive: activeFilter === RECENT_FAVORITES_FILTERS.ALL, title: t(RECENT_FAVORITES_FILTERS.ALL) })))),
            (filteredGames === null || filteredGames === void 0 ? void 0 : filteredGames.length) > 0 ? (react_1.default.createElement("div", { className: "recent-favorites-slider" },
                react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                        slider.current = swiper;
                    }, className: styles_module_scss_1.default.swiper, modules: [swiper_1.Pagination, swiper_1.Navigation], loop: false, spaceBetween: breakpoints.mobile && ((_c = Object.keys(breakpoints)) === null || _c === void 0 ? void 0 : _c.length) > 0
                        ? 6
                        : 12, slidesPerView: breakpoints.mobile && ((_d = Object.keys(breakpoints)) === null || _d === void 0 ? void 0 : _d.length) > 0
                        ? 3
                        : breakpoints.xl
                            ? 6
                            : 5, pagination: false, navigation: true, initialSlide: 2, autoplay: false }, filteredGames.map(function (game, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "slideRecentFavorites".concat(idx) },
                    react_1.default.createElement(Slide_1.default, { game: game, gameCardPlaceholder: gameCardPlaceholder }))); })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMoreButtonWrapper },
                    react_1.default.createElement(ui_components_1.LoadMoreButton, { onClick: viewAllHandler }, t('viewAll'))))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.emptyGamesContainer },
                react_1.default.createElement(ui_components_1.EmptyGames, null))))));
};
exports.default = RecentAndFavoritesGames;
